<script>
import Layout from "../../layouts/auth";
import axios from "axios";
import ErrorBag from "../../../helpers/ErrorBag";
import validation from "@/helpers/validation";

/**
 * Register component
 */
export default {
  page: {
    title: "Register",
    meta: [{ name: "description", content: '' }]
  },
  components: { Layout },
  data() {
    return {
      userType: 'super_admin',
      user: {
        super_admin: {
          name: {
            value: '',
            type: 'text',
            error: false
          },
          email: {
            value: '',
            type: 'email',
            error: false
          },
          password: {
            value: '',
            type: 'password',
            error: false
          },
          passwordConfirmation: {
            value: '',
            type: 'passwordConfirmation',
            error: false
          }
        }
      },
      errorBag: new ErrorBag()
    };
  },
  computed: {

  },
  methods: {
    async register() {
      this.errorBag.clearAll();
      if(this.isFormValid()) {

        let payload = {
          name: this.user.super_admin.name.value,
          email: this.user.super_admin.email.value,
          password: this.user.super_admin.password.value,
          password_confirmation: this.user.super_admin.passwordConfirmation.value,
          type: this.userType
        };

        try {
          this.$store.commit('loader/START_LOADING');
          await axios.post('/register', payload);
          this.$store.commit('auth/LOG_IN');
        } catch (error) {
          this.errorBag.record(error.response.data.errors);
          this.errorBag.keys().forEach((key) => {
            this.user[this.userType][key].error = true
          })
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    isFormValid () {
      let isValid = true;

      for (let type in this.user) {
        if (type === this.userType) {
          for (let field in this.user[type]) {
            // check if field is empty
            if(this.user[type][field].value === '') {
              this.user[type][field].error = true;
              isValid = false;
            }

            // check email against regex
            if(this.user[type][field].type === 'email' && !validation.email(this.user[type][field].value)) {
              this.user[type][field].error = true;
              isValid = false;
            }

            // check password length
            if(this.user[type][field].type === 'password' && this.user[type][field].value.length < 8) {
              this.user[type][field].error = true;
              isValid = false;
            }
            // check password and passwordConfirmation matching
            if(this.user[type][field].type  === 'passwordConfirmation' && this.user[type].password.value !== this.user[type].passwordConfirmation.value) {
              this.user[type][field].error = true;
              isValid = false;
            }
          }
        }
      }
      return isValid;
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">{{ $t('Register to Anytime Bigz.') }}</h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
<!--            <div>-->
<!--              <router-link tag="a" to="/">-->
<!--                <div class="avatar-md profile-user-wid mb-4">-->
<!--                  <span class="avatar-title rounded-circle bg-white">-->
<!--                    <img src="@/assets/images/logo/influcent-icon-blue.png" alt height="40" />-->
<!--                  </span>-->
<!--                </div>-->
<!--              </router-link>-->
<!--            </div>-->

            <b-alert
              v-if="errorBag.any()"
              class="mt-3"
              variant="danger"
              show=""
              dismissible
            >
              <li v-for="errorKey in errorBag.keys()" :key="errorKey">
                {{ errorBag.get(errorKey) }}
              </li>
            </b-alert>

            <b-form class="p-2" @submit.prevent="register">
              <b-form-group>
                <b-form-radio-group v-model="userType">
                  <label>You are:</label>
                  <div class="row">
                    <div class="col">
                      <b-form-radio value="super_admin" class="mb-1">Super admin</b-form-radio>
                    </div>
                  </div>
                </b-form-radio-group>
              </b-form-group>

              <div v-if="userType === 'super_admin'">
                <b-form-group label="Name:" label-for="clientEmail">
                  <b-form-input
                      id="name"
                      name="name"
                      v-model="user.super_admin.name.value"
                      @input="user.super_admin.name.error = false"
                      type="text"
                      placeholder="Enter name"
                      :class="{ 'is-invalid': user.super_admin.name.error }"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Email:" label-for="clientEmail">
                  <b-form-input
                          id="clientEmail"
                          name="email"
                          v-model="user.super_admin.email.value"
                          @input="user.super_admin.email.error = false"
                          type="text"
                          placeholder="Enter email"
                          :class="{ 'is-invalid': user.super_admin.email.error }"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Password:" label-for="clientPassword">
                  <b-form-input
                          id="clientPassword"
                          name="password"
                          v-model="user.super_admin.password.value"
                          @input="user.super_admin.password.error = false"
                          type="password"
                          placeholder="Enter password"
                          :class="{ 'is-invalid': user.super_admin.password.error }"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Repeat password:" label-for="clientPasswordConfirmation">
                  <b-form-input
                          id="clientPasswordConfirmation"
                          v-model="user.super_admin.passwordConfirmation.value"
                          @input="user.super_admin.passwordConfirmation.error = false"
                          type="password"
                          placeholder="Repeat password"
                          :class="{ 'is-invalid': user.super_admin.passwordConfirmation.error }"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block">Register</b-button>
              </div>

              <div class="mt-4 text-center">
                <p class="mb-0">
                  By registering you accept our
                  <a
                    href="https://influencertes.com/terms-and-conditions.html"
                    target="_blank"
                    class="text-primary"
                  >Terms and conditions</a>
                </p>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Already have account ?
            <router-link tag="a" to="/login" class="font-weight-medium text-primary">Log in</router-link>
          </p>
          <p>
            © {{ new Date().getFullYear() }} Bigz
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
